/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note1/view.blocks to change it.
import Note from './Note/index'
import NoteTemplate from './NoteTemplate/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Note1({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Edit/Note"
  
}) {
  return (<React.Fragment
>
<Note
  viewPath={`${viewPath}/Note`}
/>
<NoteTemplate
  viewPath={`${viewPath}/NoteTemplate`}
/>
{children}
</React.Fragment>)
}